<template>
	<div>
		<b-breadcrumb>Categories</b-breadcrumb>
		<b-input v-model="q" placeholder="Search..." @input="loadCategories()" class="mb-2"></b-input>
		<b-table small striped hover :items="categories" :busy="loading>0" :fields="['id', 'name',{ label: '', key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]">
			<template #head(actions)="">
				<b-button @click="$refs.editModal.show()" variant="success" size="sm" v-b-tooltip.hover.left.v-success title="Add a category"><b-icon icon="plus"></b-icon></b-button>
			</template>
			<template #cell(name)="data">
				<router-link :to="{ name: 'Category', params: { id: data.item.id } }">{{data.item.name}}</router-link>
			</template>
			<template #cell(actions)="data">
				<b-dropdown right size="sm" variant="default">
					<b-dropdown-item @click="$refs.editModal.show(data.item.id)"><b-icon icon="pencil-fill"></b-icon> Edit category</b-dropdown-item>
					<b-dropdown-item @click="$refs.deleteModal.show(data.item.id)" variant="danger"><b-icon icon="trash"></b-icon> Delete category</b-dropdown-item>
				</b-dropdown>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<category-edit-modal ref="editModal" @saved="loadCategories"></category-edit-modal>
		<category-delete-modal ref="deleteModal" @deleted="loadCategories"></category-delete-modal>
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';
import CategoryEditModal from '@/components/Category/Modal/Edit.vue';
import CategoryDeleteModal from '@/components/Category/Modal/Delete.vue';

export default {
	name: 'Categories',
	components: {
		Pager,
		CategoryEditModal,
		CategoryDeleteModal,
	},
	data() { return {
		categories: [],
		error: null,
		loading: 0,
		total: 0,
		skip: 0,
		perPage: 10,
		q: undefined,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip||0)||0;
		this.perPage = parseInt(this.$route.query.perPage||10)||10;
		this.loadCategories();
	},
	watch: {
		'$route': 'loadCategories',
		'q': 'loadCategories',
	},
	methods: {
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage }});
		},
		loadCategories() {
			this.loading++;
			this.error = null;
			this.$api.get('categories', { q: this.q||'', limit: this.perPage, skip: this.skip }).then(categories => {
				this.categories = categories.results;
				this.total = categories.total;
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
	},
};
</script>
